import React from 'react'

import { Container } from '@components/Container'
import { TopChartSection } from '@components/TopChartSection'
import { BookTopChartProvider } from '@hooks/book/useBookTopChart'
import { BookTopChartEnum } from '@interfaces/BookTopChartEnum'
import { GoToTopButton } from '@components/GoToTopButton'
import { Popup } from '@components/Popup'
import { PopupBannerScreenEnum } from '@interfaces/PopupBannerScreenEnum'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { BannerSection } from './components/BannerSection'
import { HighlightBanner } from './components/HighlightBanner'
import { ContinueToRead } from './components/ContinueToRead'
import { BookTopChart } from './components/BookTopChart'
import { CategoryMenu } from './components/CategoryMenu'
import { DailyTopChartCharacter } from './components/DailyTopChartCharacter'
import { EbookDiscount } from './components/EbookDiscount'
import { EbookNew } from './components/EbookNew'
import { HomePageProps } from './interface'
import { LatestUpdateBook } from './components/LatestUpdateBook'
import { Newest } from './components/Newest'

export const HomePage = React.memo(
  ({
    serverDate,
    highlightBannersTop,
    highlightBannersBottom,
    isLoading,
  }: HomePageProps) => {
    return (
      <>
        <BannerSection />
        <Container className='tablet-mobile:mt-[30px] tablet-mobile:!py-0 desktop:!py-[0px]'>
          <CategoryMenu className='desktop:hidden mb-[20px] mobile:pl-[20px]' />
          <ContinueToRead />
          <section className='flex flex-col mt-[60px] tablet-mobile:mt-[40px]'>
            <BookTopChartProvider
              bookTopChartType={BookTopChartEnum.PURCHASE}
              limit={10}
              serverDate={serverDate}
            >
              <BookTopChart
                title='เรื่องฮิตขายดี'
                type='top-purchase'
                disabledClassName='opacity-30'
              />
            </BookTopChartProvider>
            <BookTopChartProvider
              bookTopChartType={BookTopChartEnum.VIEW}
              limit={10}
              serverDate={serverDate}
            >
              <BookTopChart
                title='เรื่องยอดนิยม'
                className='mt-[60px] tablet-mobile:mt-[40px]'
                type='top-view'
                disabledClassName='opacity-30'
              />
            </BookTopChartProvider>
          </section>
          <HighlightBanner
            className='mt-[60px] tablet-mobile:mt-[40px]'
            highlightBanners={highlightBannersTop}
            isLoading={isLoading}
          />
          <div className='mt-[60px] tablet-mobile:mt-[40px]'>
            <DailyTopChartCharacter />
          </div>
        </Container>
        <TopChartSection
          className='mt-[60px] tablet-mobile:mt-[40px] bg-character-bg dark:bg-character-bg-dark bg-no-repeat bg-cover px-[100px] py-[50px] tablet-mobile:px-0 tablet-mobile:py-[38px] h-full'
          classNameTitle='text-white tablet-mobile:px-[20px]'
          selectClassName='text-[#94e7ff]'
          title='ท็อปชาร์ตตัวละคร'
          canViewAll
        />
        <Container className='tablet-mobile:!py-0 desktop:!py-[0px]'>
          <HighlightBanner
            className='mt-[60px] tablet-mobile:mt-[40px] mb-[60px] tablet-mobile:mb-[40px]'
            highlightBanners={highlightBannersBottom}
            isLoading={isLoading}
          />
          <LatestUpdateBook
            className='pb-[60px] tablet-mobile:pb-[40px]'
            direction='horizontal'
            isShowNavigation
          />
          <Newest
            className='pb-[60px] tablet-mobile:pb-[40px]'
            direction='horizontal'
            isShowNavigation
          />
          {SHOW_EBOOK_FEATURE && (
            <>
              <EbookDiscount direction='horizontal' isShowNavigation />
              <EbookNew
                className='pb-[60px] tablet-mobile:pb-[40px]'
                direction='horizontal'
                isShowNavigation
              />
            </>
          )}
        </Container>
        <GoToTopButton className='desktop:hidden bottom-[72px]' />
        <Popup screen={PopupBannerScreenEnum.Home} />
      </>
    )
  }
)
